import { Link, useMatches } from '@tanstack/react-router';
import { ChevronRight } from 'lucide-react';
import { Fragment } from 'react';

interface CrumbStatic {
  breadcrumb?: string;
}

export const Breadcrumbs = () => {
  const matches = useMatches();
  const crumbs = matches
    .filter((m): m is typeof m & { staticData: CrumbStatic } =>
      Boolean((m.staticData as CrumbStatic | undefined)?.breadcrumb),
    )
    .map((m) => ({
      id: m.routeId,
      label: (m.staticData as CrumbStatic).breadcrumb ?? '',
      pathname: m.pathname,
    }));

  if (crumbs.length === 0) return null;

  return (
    <nav aria-label="breadcrumbs" className="flex items-center gap-1 text-sm text-muted-foreground">
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1;
        return (
          <Fragment key={crumb.id}>
            {index > 0 ? <ChevronRight className="h-3.5 w-3.5" /> : null}
            {isLast ? (
              <span className="text-foreground">{crumb.label}</span>
            ) : (
              <Link to={crumb.pathname} className="hover:text-foreground">
                {crumb.label}
              </Link>
            )}
          </Fragment>
        );
      })}
    </nav>
  );
};
